import { z } from "zod";
import { gameProviderSchema, orientationSchema } from "./catalog";

export const playResponseSchema = z.object({
  slug: z.string(),
  provider: gameProviderSchema,
  url: z.string(),
  orientation: orientationSchema,
  session: z
    .object({
      token: z.string(),
      heartbeatIntervalSeconds: z.number().int().positive(),
    })
    .nullable(),
});
export type PlayResponse = z.infer<typeof playResponseSchema>;

export const heartbeatInputSchema = z.object({ token: z.string().min(1).max(512) });
export const viewEventInputSchema = z.object({ slug: z.string().min(1).max(120) });
